import { render } from "./ProductTableGroupBy.vue?vue&type=template&id=620bb0ee"
import script from "./ProductTableGroupBy.vue?vue&type=script&lang=js"
export * from "./ProductTableGroupBy.vue?vue&type=script&lang=js"

import "./ProductTableGroupBy.vue?vue&type=style&index=0&id=620bb0ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__